<script setup lang="ts">
/*
 * Карточка задачи, у которой ещё нет исполнителя (самой задачи на бэке может не быть).
 * Показывается в правой панели форм с основанием (НС, Заявка, ППУ, Аудит) вместо TaskCard
 * и повторяет её визуал: шапка с заголовком и строка «Исполнитель» с кнопкой «Назначить».
 * Назначение выполняет форма по событию assign — задачу создаёт бэк.
 */
import { useDisplay } from 'vuetify'

withDefaults(defineProps<{
  title: string
  /** Подпись строки исполнителя (у задач координатора — «Исполнитель -\nкоординатор») */
  performerLabel?: string
  /** Пояснение под заголовком */
  hint?: string
  canAssign?: boolean
  assignLabel?: string
}>(), {
  performerLabel: 'Исполнитель',
  hint: '',
  canAssign: false,
  assignLabel: 'Назначить',
})

const emit = defineEmits<{
  (e: 'assign'): void
}>()

const { xs } = useDisplay()
</script>

<template>
  <div class="task-card-root d-flex flex-column h-100 overflow-hidden bg-surface">
    <header class="flex-shrink-0 pb-2" :class="xs ? 'px-4 pt-3' : 'px-6 pt-6'">
      <h2 class="task-card-title text-high-emphasis mb-0">
        {{ title }}
      </h2>
      <span v-if="hint" class="text-body-1 task-unassigned-hint">{{ hint }}</span>
    </header>

    <div class="flex-grow-1 overflow-y-auto py-2" :class="xs ? 'px-4' : 'px-6'" style="min-height: 0;">
      <div class="d-flex align-center" style="min-height: 36px;">
        <span class="metadata-label">{{ performerLabel }}</span>
        <div class="metadata-value d-flex align-center">
          <VBtn
            v-if="canAssign"
            variant="text"
            color="primary"
            density="comfortable"
            class="px-2 text-none font-weight-medium"
            prepend-icon="ri-user-add-line"
            @click="emit('assign')"
          >
            {{ assignLabel }}
          </VBtn>
          <span v-else class="text-body-2 text-medium-emphasis">Не назначен</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
// Типографика как в TaskCard, чтобы карточка не выглядела инородной рядом с ней
.task-card-root {
  min-height: 480px;
}

.task-card-title {
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}

.metadata-label {
  width: 140px;
  flex-shrink: 0;
  white-space: pre-line;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: rgb(var(--v-theme-secondary));
}

.metadata-value {
  flex-grow: 1;
}

// В теме нет токена прозрачности 0.55 — цвет из темы, прозрачность числом
.task-unassigned-hint {
  color: rgba(var(--v-theme-text-primary), 0.55);
}
</style>
